import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import {
  Button,
  Grid,
  TextareaAutosize,
  Typography,
  Box,
  Modal,
} from "@material-ui/core";
import Backbutton from "../../Backbutton";

import { Formik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { connect } from "react-redux";
import { CircularProgress } from '@material-ui/core';


import SweetAlert from "react-bootstrap-sweetalert";
import ImageUploader from "react-images-upload";

let schema = yup.object({
  productbucketname: yup.string().required("Name is Required").typeError(""),
});

function ProductBucketEdit({ server, history, access_token, role, location }) {

  const [errortext, seterrortext] = useState("");
  const [alert, setAlert] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [onLoading, setOnLoading] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (role?.id !== 1) {
      if (role?.id === 2) {
        history.push("/Distributer");
      }
      if (role?.id === 3) {
        history.push("/Retailer");
      }
      if (role?.id === 4) {
        history.push("/Games");
      }
    }
  }, []);

  const hideAlert = () => {
    setAlert(null);
  };
  const added = () => {
    setAlert(
      <SweetAlert success title="Updated Successfully" onConfirm={hideAlert}>
        Product bucket has been updated
      </SweetAlert>
    );

    history.push('/ProductBucket')
    
  };
  const editValue = (values, resetForm) => {

    setOnLoading(true);

    const bodyParameters = {
      name: values.productbucketname,
      _method: "put",
    };
    const data = new FormData();

    Object.keys(bodyParameters).forEach((key) => {
      data.set(key, bodyParameters[key]);
    });

  
    const config = {
      headers: { Authorization: `Bearer ${access_token}` },
    };

    axios
      .post(server + "api/product-bucket/" + location.state[0].id, data, config)
      .then((response) => {
       
        added();
        resetForm();
        seterrortext("");
      })
      .catch((error) => {
        const errormessage = error.response.data.errors.alias[0];
        seterrortext(errormessage);
        setOnLoading(false);
      });
  };
 

  return (
    <div className="grayBackgroundBox">
      {alert}
      <div className="card container">
        <Formik
          initialValues={{
            productbucketname: location?.state[0]?.name,            
          }}
          validationSchema={schema}
          onSubmit={(values, { resetForm }) => {
            console.log(values);
            editValue(values, resetForm);
          }}
        >
          {({
            values,
            handleBlur,
            handleChange,
            handleSubmit,
            errors,
            touched,
            isSubmitting,
            isValid,
          }) => (
            <form className="container" onSubmit={handleSubmit}>
              <div style={{ textAlign: "start" }}>
                <Backbutton />
              </div>
              <div className="title">Edit Product Bucket</div>
              <Grid container>
                <Grid item xs={12} md={6}>
                  <div>
                    <div className="row">
                      <div className="col-12 col-md-6 inputFieldContainer">
                        <TextField
                          className="inputField"
                          id="standard-basic"
                          label="Product bucket name*"
                          name="productbucketname"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.productbucketname}
                        />
                        {errors.productbucketname && (
                          <p style={{ color: "red" }}>{errors.productbucketname}</p>
                        )}
                      </div>
                      
                    </div>
                    
                  </div>
                </Grid>
               
              </Grid>
              <div style={{ textAlign: "center" }} className="text-center mt-5">
                <Button
                  className="formSubmit"
                  variant="contained"
                  type="submit"
                  color="primary"
                  disabled={!isValid}
                  disableElevation
                  style={{backgroundColor:'#F05225'}}
                >
                  {onLoading ? <CircularProgress style={{color:'white'}} /> : "Save Product Bucket"}
                </Button>
              </div>
            </form>
          )}
        </Formik>
        
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  server: state.auth.server,
  access_token: state.auth.access_token,
  role: state.auth.role[0],
});

export default connect(mapStateToProps, {})(ProductBucketEdit);
